import {IssueBodyLoading} from '@github-ui/issue-body/IssueBodyLoading'
import {clsx} from 'clsx'
import {type FC, useRef} from 'react'

import {ContentWrapper} from './ContentWrapper'
import {HeaderLoading} from './header/HeaderLoading'
import {IssueTimelineLoading} from './IssueTimelineLoading'
import styles from './IssueViewerLoading.module.css'
import type {OptionConfig} from './OptionConfig'
import {SidebarSectionsLoading} from './sections/SidebarSectionsLoading'

type IssueViewerLoadingProps = {
  optionConfig: Pick<OptionConfig, 'useViewportQueries'>
}

export const IssueViewerLoading: FC<IssueViewerLoadingProps> = ({optionConfig}) => {
  const issueViewerContainerRef = useRef<HTMLDivElement>(null)
  return (
    <ContentWrapper>
      <div ref={issueViewerContainerRef} data-testid="issue-viewer-loading" className={styles.loadingContainer}>
        <div className={styles.headerLoadingWrapper}>
          <HeaderLoading />
        </div>
        <div
          className={clsx(
            styles.contentAndSidebarWrapper,
            optionConfig.useViewportQueries
              ? styles.contentAndSidebarWrapper_viewport
              : styles.contentAndSidebarWrapper_container,
          )}
        >
          <div
            className={clsx(
              styles.contentLoadingArea,
              optionConfig.useViewportQueries
                ? styles.contentLoadingArea_viewport
                : styles.contentLoadingArea_container,
            )}
          >
            <div>
              <IssueBodyLoading />
            </div>
            <div>
              <div className={styles.timelineLoadingWrapper}>
                <IssueTimelineLoading />
              </div>
            </div>
          </div>

          <div
            className={clsx(
              styles.sidebarLoadingArea,
              optionConfig.useViewportQueries
                ? styles.sidebarLoadingArea_viewport
                : styles.sidebarLoadingArea_container,
            )}
          >
            <SidebarSectionsLoading />
          </div>
        </div>
      </div>
    </ContentWrapper>
  )
}

try{ IssueViewerLoading.displayName ||= 'IssueViewerLoading' } catch {}